export const courseTabs = [
  {
    title: "دورة الرخصة المهنية ",
    id: "Original",
  },
  // {
  //   title: "دورة الأسئلة الاكترونية",
  //   id: "QuestionsPackage",
  // },
];
